import React, { useEffect, useState } from 'react';
import { VStack, View } from 'native-base';

// Components
import { ChatHeader, ChatMessagesContainer } from '../../';

// Classes & Types
import { Streak, Room, IMessageExt } from '@breakroom-nx/classes';
import { Status } from '@breakroom-nx/helpers';

// Redux
import {
  useGetCurrentUserQuery,
  useGetMembersForRoomQuery,
  useUserJoinedChatMutation,
  useAppDispatch,
  openModal,
} from '@breakroom-nx/redux';

export interface ChatRoomProps {
  room: Room;
}

export function ChatRoom({ room }: ChatRoomProps) {
  const dispatch = useAppDispatch();
  const { data: currentUser } = useGetCurrentUserQuery();
  const [joiningRoom, setJoiningRoom] = useState<boolean>(false);
  const [isPreview, setIsPreview] = useState<boolean>(true);
  const [joinChat] = useUserJoinedChatMutation();

  // Members
  const { data: members, isLoading: isLoadingMembers } =
    useGetMembersForRoomQuery(room);

  // Update Members
  useEffect(() => {
    if (members) {
      if (members.some((member) => member.uid === currentUser?.uid)) {
        setIsPreview(false);
      } else {
        setIsPreview(true);
      }
    }
  }, [members, currentUser, room.id]);

  useEffect(() => {
    // console.log('Rendered Chat Roome');
    return () => {
      // console.log('Unmounted Chat Room');
    };
  }, []);

  useEffect(() => {
    // console.log('Re-rendering Chat Roome');
  });

  return (
    <View flex={1} justifyContent={'flex-end'}>
      <VStack height={'full'} flex={1}>
        <ChatHeader
          members={members}
          created={room.created}
          expires={room.expires}
          streak={new Streak(room.streakDuration())}
          isLoading={isLoadingMembers}
        />
        <ChatMessagesContainer room={room} isPreview={isPreview} />
      </VStack>
    </View>
  );
}

export default React.memo(ChatRoom);
